const campaignRoute = [
  {
    path: '/campaign/campaign-list',
    name: 'CampaignList',
    authed: 'CampaignList',
    component: () => import('@/views/campaign/CampaignList/index.vue'),
    meta: {
      tabName: 'Campaign List',
      title: 'CAMPAIGN LIST',
      group: 'Campaign Mgmt.',
      icon: 'mdiMapMarker',
      groupSort: 30,
    },
  },
  {
    path: '/campaign/campaign-list/new-campaign',
    name: 'NewCampaign',
    authed: 'NewCampaign',
    component: () => import('@/views/campaign/CampaignList/newCampaign.vue'),
    meta: {
      tabName: 'Campaign Detail Edit',
      group: 'Campaign Mgmt.',
      isHide: true,
      canEdit: true, // 标识是否是可编辑页面 用来做关闭提示需要
    },
  },
  {
    path: '/campaign/campaign-list/edit-campaign',
    name: 'EditCampaign',
    authed: 'EditCampaign',
    component: () => import('@/views/campaign/CampaignList/editCampaign.vue'),
    meta: {
      tabName: 'Campaign Detail Edit',
      group: 'Campaign Mgmt.',
      isHide: true,
      canEdit: true,
    },
  },
  {
    path: '/campaign/campaign-list/campaign-detail',
    name: 'CampaignDetail',
    authed: 'CampaignDetail',
    component: () =>
      import('@/views/campaign/CampaignList/campaignDetail/index.vue'),
    meta: {
      tabName: 'Campaign Detail',
      group: 'Campaign Mgmt.',
      isHide: true,
      canEdit: false,
    },
  },
  {
    path: '/campaign/lottery-list',
    name: 'LotteryList',
    authed: 'LotteryList',
    component: () => import('@/views/campaign/LotteryList/index.vue'),
    meta: {
      tabName: 'Lottery List',
      title: 'LOTTERY LIST',
      group: 'Campaign Mgmt.',
    },
  },
  {
    path: '/campaign/lottery-list/lottery-info',
    name: 'LotteryInfo',
    authed: 'LotteryInfo',
    component: () =>
      import('@/views/campaign/LotteryList/LotteryInfo/index.vue'),
    meta: {
      tabName: 'Lottery detail',
      isHide: true,
      title: 'lottery detail',
      group: 'Campaign Mgmt.',
    },
  },
]

export default campaignRoute
